/**
 * ResponsavelFilialCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponsavelFilial} from '@/model/resource/ResponsavelFilial'

/* TODO: review generated class */
@HttpExclude()
export class ResponsavelFilialCollection extends PageCollection<
  ResponsavelFilial
> {
  constructor() {
    super(ResponsavelFilial)
  }

  queryAsPage() {
    return this.listResponsavelFilial()
  }

  async listResponsavelFilial() {
    return await Request.get(`/admin/responsavel-filial`, {params: this.params})
      .name('listResponsavelFilial')
      .as(this)
      .getResponse()
  }

  async listCsvResponsavelFilial() {
    return await Request.get(`/admin/responsavel-filial/csv`, {
      params: this.params,
    })
      .name('listCsvResponsavelFilial')
      .as(this)
      .getResponse()
  }
}
